import { CommandHandler } from '../../_base/actionBus/CommandHandler';
import { RegisterDeviceToken } from './RegisterDeviceToken';

export abstract class RegisterDeviceTokenHandler implements CommandHandler<RegisterDeviceToken> {
    abstract handle(command: RegisterDeviceToken): Promise<void>;
}